import { useState } from "react";

type SingleStationReciprocatingShuttleControlsProps = {
  disabled?: boolean;
  initialHeight: number;
  onHeightChange: (height: number) => void;
};

export function SingleStationReciprocatingShuttleControls({
  disabled = false,
  initialHeight,
  onHeightChange
}: SingleStationReciprocatingShuttleControlsProps) {
  const [heightDraft, setHeightDraft] = useState(String(initialHeight));

  return (
    <div className="single-station-reciprocating-shuttle-controls">
      <span className="single-station-reciprocating-shuttle-controls-title">
        单工位往复式穿梭车
      </span>
      <label className="single-station-reciprocating-shuttle-controls-field">
        <span>车身高度</span>
        <span className="single-station-reciprocating-shuttle-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0.001"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setHeightDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue > 0) {
                onHeightChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={heightDraft}
          />
          <span>m</span>
        </span>
      </label>
    </div>
  );
}
